var T = Object.defineProperty;
var m = (e, t, s) => t in e ? T(e, t, { enumerable: !0, configurable: !0, writable: !0, value: s }) : e[t] = s;
var E = (e, t, s) => m(e, typeof t != "symbol" ? t + "" : t, s);
var A = /* @__PURE__ */ ((e) => (e.OPTIONAL = "OPTIONAL", e.MANDATORY = "MANDATORY", e.HIDDEN = "HIDDEN", e.READ_ONLY = "READ_ONLY", e))(A || {}), S = /* @__PURE__ */ ((e) => (e.DATE = "DATE", e.TEXT = "TEXT", e.TEXT_AREA = "TEXT_AREA", e.NUMBER = "NUMBER", e.REFID = "REFID", e))(S || {}), N = /* @__PURE__ */ ((e) => (e.SINGLE = "SINGLE", e.MULTIPLE = "MULTIPLE", e))(N || {});
const M = ".";
class G {
  constructor() {
    E(this, "processors", []);
  }
  register(t) {
    this.processors.push(t);
  }
  processExtensions(t) {
    Object.entries(t.currentState).forEach(([s, n]) => {
      const r = n.extensions ?? [], o = {
        field: s,
        runtimeContext: t
      };
      r.forEach((c) => {
        this.processors.filter((i) => i.canProcess(c)).forEach((i) => i.process(c, o));
      });
    });
  }
}
const O = (e) => `[${e}]`, K = (e, t, s) => s == null ? e : e.replace(t, s.toString()), D = (e, t, s) => {
  if (!t || t.length === 0)
    return e;
  let n = e;
  for (const r of t)
    n = K(n, s(r), r.index);
  return n;
}, L = (e, t) => e.getExpressionBuilder().indexReplacement(t), q = (e) => e.join(M), V = (e, t) => {
  const { fieldIndices: s, pattern: n, valueAttribute: r } = t, o = D(
    n,
    s,
    (c) => L(e, c.idxVar)
  );
  return r ? q([o, r]) : o;
}, _ = (e, t, s) => {
  const r = {
    expression: V(e, s),
    data: t,
    variables: {}
  };
  return e.getExpService().evaluate(r).value;
}, $ = (e) => ({
  pattern: e.pattern,
  valueAttribute: e.valueAttribute,
  fieldIndices: []
}), w = (e, t, s, n) => {
  const o = {
    pattern: e.getExpressionBuilder().resolveAttributePath(`${s.attr}${O(n)}`)
  }, c = $(o);
  return _(e, t, c);
}, z = (e, t, s) => {
  try {
    const r = {
      expression: e.getExpressionBuilder().sizeOf(s),
      data: t,
      variables: {}
    }, c = e.getExpService().evaluate(r).value;
    return typeof c == "number" ? c : -1;
  } catch (n) {
    const r = t ? JSON.stringify(t) : "null";
    return console.error(`Failed to getSize(${r}, "${s}"):`, n), -1;
  }
}, P = (e, t, s, n, r) => {
  if (s) {
    const o = e.getExpressionBuilder().resolveAttributePath(s.attr), c = z(e, t, o);
    for (let i = 0; i < c; i++) {
      const { idxVar: l, uiIdxVar: a } = s, u = [...n], d = {
        index: i,
        idxVar: l,
        uiIdxVar: a
      };
      u.push(d);
      const x = w(e, t, s, i);
      P(e, x, s.forEach, u, r);
    }
  } else {
    const o = { fieldIndices: n };
    r.push(o);
  }
}, p = (e, t, s) => {
  const n = [];
  return P(e, t, s, [], n), n;
}, h = (e) => e ? e.fieldIndices : [], B = (e, t) => (e.forEach ? e.forEach.uiIdxVar : null) ? t : [], g = (e, t) => {
  const s = B(e, t);
  return D(e.elementId, s, (n) => n.uiIdxVar);
}, U = (e, t, s) => {
  const n = {};
  return (t.entries || []).forEach((o) => {
    const { elementId: c, forEach: i, ...l } = o;
    i == null ? n[c] = {
      ...l
    } : p(e, s, i).forEach((u) => {
      const d = h(u), x = g(o, d);
      n[x] = {
        ...l
      };
    });
  }), n;
}, C = (e, t, s) => {
  const n = {};
  return (t.entries || []).forEach((o) => {
    const { elementId: c, forEach: i, ...l } = o;
    i == null ? n[c] = {
      ...l
    } : p(e, s, i).forEach((u) => {
      const d = h(u), x = g(o, d);
      n[x] = {
        ...l
      };
    });
  }), n;
}, I = (e, t, s, n) => {
  const r = {};
  (s.variables.entries || []).forEach(({ key: a, value: u }) => r[a] = u), n.forEach(({ idxVar: a, index: u }) => r[a] = u);
  const i = {
    expression: s.expression,
    data: t,
    variables: r
  };
  return e.getExpService().evaluate(i).value === !0;
}, v = (e, t, s) => {
  s.push({ key: t, value: e.consequences });
}, f = (e, t, s, n) => {
  for (const r of s) {
    const { forEach: o, condition: c } = r;
    o == null ? I(e, t, c, []) && (v(r, null, n), f(e, t, r.branches, n)) : p(e, t, o).forEach((l) => {
      const a = h(l);
      I(e, t, c, a) && (v(r, l, n), f(e, t, r.branches, n));
    });
  }
}, y = (e, t) => {
  const s = Object.keys(t);
  for (let n = 0; n < s.length; n++) {
    const r = s[n], o = t[r], c = e[r];
    if (o !== c)
      return !1;
  }
  return !0;
}, b = (e) => {
  const t = {};
  return h(e).forEach((n) => {
    t[n.uiIdxVar] = n.index;
  }), t;
}, Y = (e, t) => {
  const s = b(e), n = b(t);
  return y(s, n) || y(n, s);
}, R = (e, t, s) => {
  const n = e ? h(e) : [], r = g(t, n), o = s[r] ?? {
    displayRuleType: A.HIDDEN,
    codeTables: null,
    extensions: []
  }, { displayRuleType: c, codeTables: i, extensions: l, ...a } = t, u = [...o.extensions, ...l];
  s[r] = {
    displayRuleType: c || o.displayRuleType,
    codeTables: i || o.codeTables,
    extensions: u,
    ...a
  };
}, j = (e, t, s, n) => {
  const { key: r, value: o } = s;
  o.forEach((c) => {
    const { forEach: i } = c;
    i ? p(e, n, i).forEach((a) => {
      Y(a, r) && R(a, c, t);
    }) : R(r, c, t);
  });
}, F = (e, t, s, n) => {
  s.forEach((r) => {
    const o = [];
    f(e, n, r.branches, o), o.forEach((c) => j(e, t, c, n));
  });
}, X = (e, t) => !t || t.length === 0 ? e : `${e}_${t.join("_")}`, H = (e, t) => `${e}_${t}`;
class J {
  constructor() {
    E(this, "provider");
    E(this, "consequenceExtensionProcessorRegistry");
    E(this, "setProvider", (t) => {
      this.provider = t;
    });
    E(this, "setConsequenceExtensionProcessorRegistry", (t) => {
      this.consequenceExtensionProcessorRegistry = t;
    });
    E(this, "applyDefaultMetadata", (t, s) => {
      if (!this.provider)
        throw new Error("[ExpServiceProvider] is not initialized");
      return U(this.provider, t, s);
    });
    E(this, "applyDefaultState", (t, s) => {
      if (!this.provider)
        throw new Error("[ExpServiceProvider] is not initialized");
      return C(this.provider, t, s);
    });
    E(this, "applyDisplayRuleDefinitions", (t, s, n) => {
      if (!this.provider)
        throw new Error("[ExpServiceProvider] is not initialized");
      if (F(this.provider, t, s, n), this.consequenceExtensionProcessorRegistry) {
        const r = {
          currentState: t,
          data: n
        };
        this.consequenceExtensionProcessorRegistry.processExtensions(r);
      }
    });
    E(this, "getDisplayRuleElementId", (t, s) => X(t, s));
    E(this, "getDisplayRuleKey", (t, s) => H(t, s));
  }
}
export {
  G as ConsequenceExtensionProcessorRegistry,
  J as DisplayRuleService,
  A as DisplayRuleType,
  S as FieldType,
  M as NESTED_PROPERTY_DELIMITER,
  N as RefAttrType
};
